import { signalStore, withHooks, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { withComparisonValueSelectors } from './comparison-value.selectors';
import { ComparisonValue } from '../../models/geo-data';
import { ComparisonValueService } from '../../services/comparison-value.service';
import { withLogging } from '../features/logger.feature';

export type ComparisonValueState = BaseState<ComparisonValue>;

export const initialState: ComparisonValueState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'ComparisonValue',
  entityLabel: 'Vergleichswert',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const ComparisonValueStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<ComparisonValue>(ComparisonValueService),
  withLogging(initialState.entityType),
  withComparisonValueSelectors(),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
  })
);
